// Global support widget (Phase 2 of the Master Development Roadmap) — founder
// side. Backed by the WhatsApp module's "website" channel (WaSupportTicket +
// WaWebsiteMessage), which already has a working SLA-escalation sweep.
//
// Unlike the student-facing apps, the backend's postWebsiteMessage/getWebsiteThread
// only auto-resolves identity for req.user.type === "student" -- a founder
// token doesn't match that, so name/email must be passed explicitly here
// (pulled from the founder's own profile). The ticket still isn't linked to
// a Student record, which is fine; it's keyed by email instead.
import axios from "axios";

const BASE_URL = import.meta.env.VITE_STN_API_URL || "http://localhost:4000";

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("stn-token");
  if (token) config.headers["accessToken"] = token;
  return config;
});

api.interceptors.response.use(
  (r) => r.data?.res ?? r.data,
  (err) => {
    const msg =
      err.response?.data?.err?.msg ||
      err.response?.data?.message ||
      err.message ||
      "Something went wrong.";
    const e = new Error(msg);
    e.status = err.response?.status || 0;
    return Promise.reject(e);
  },
);

export const postSupportMessage = (message, name, email) =>
  api.post("/whatsapp/website/message", { message, name, email });

export const getSupportThread = (email) =>
  api.get("/whatsapp/website/thread", { params: { email } });
